<template>
    <div class="resource-center">
        <div class="tab-area">
            <secondTab @switchTab="switchTab" :barData="barData"></secondTab>
        </div>
        <div class="resource-center-wrap" id="customList">
            <div class="wrap-scorll">
                <resourceCenterCard v-for="(item, index) in cardData" :key="index" :id="item.id" :title="item.title"
                    :content="item.content">
                </resourceCenterCard>
            </div>
        </div>
    </div>
</template>

<script>
import resourceCenterCard from '../components/resourceCenterCard.vue';
import secondTab from '../components/base/secondTab.vue';
export default {
    name: 'resourceCenter',
    components: { secondTab, resourceCenterCard },
    props: {
        backendData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            currentTab: 0,
        };
    },
    computed: {
        barData() {
            return this.cardData.map(item => {
                return {
                    title: item.title
                }
            })
        },
        cardData() {
            let cardData = [{
                title: '世界觀',
                id: 'anchor1',
                backTag: 404,
                content: []
            },
            {
                title: '系統介紹',
                id: 'anchor2',
                backTag: 403,
                content: []
            },
            {
                title: '玩法說明',
                id: 'anchor3',
                backTag: 402,
                content: []
            }]
            if (this.backendData && this.backendData.length > 0) {
                this.backendData.forEach(item => {
                    if (item.tagId == cardData[0].backTag) {
                        cardData[0].content.push(item)
                    } else if (item.tagId == cardData[1].backTag) {
                        cardData[1].content.push(item)
                    } else if (item.tagId == cardData[2].backTag) {
                        cardData[2].content.push(item)
                    }
                })
            }
            return cardData
        }
    },
    methods: {
        switchTab(index) {
            this.currentTab = index;
            let id = this.cardData[index].id;
            document.getElementById(id).scrollIntoView({
                behavior: 'smooth'
            });
        }
    },
    activated() {
        this.$nextTick(() => {
            let id = this.cardData[this.currentTab] ? this.cardData[this.currentTab].id : 0;
            let el = document.getElementById(id);
            if (el) {
                el.scrollIntoView();
            }
        })
    }
};
</script>

<style lang='scss' scoped>
.resource-center {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;

    ::-webkit-scrollbar {
        -webkit-appearance: none;
    }

    ::-webkit-scrollbar:vertical {
        width: 0rem;
    }

    ::-webkit-scrollbar:horizontal {
        height: 0rem;
    }

    .tab-area {
        background-color: white;
        position: sticky;
        top: 0;
        z-index: 2;
    }

    &-wrap {
        flex: 1;
        position: relative;
        overflow-y: auto;

        .wrap-scorll {
            padding-bottom: 2rem;
        }
    }


}

.isPad {
    .resource-center {
        &-wrap {
            overflow: hidden;
        }
    }
}
</style>